"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("_");

var _makeBaseSampleTimelineEvent = _interopRequireDefault(require("crm_ui/utils/sampleData/makeBaseSampleTimelineEvent"));

/*

  This interface has two intended purposes:
    1. to enforce consistency between sample event factories.
    2. Abstract away implementation details for composing a sample
       event from the base sample event factory (makeBaseSampleTimelineEvent).

*/
var SampleEventFactoryInterface = function SampleEventFactoryInterface() {
  var interfaceData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    // Data required for all timeline events.
    requiredData: {},
    // Data specific to the event type.
    eventDefaults: {},
    // Callback for building unique event type,
    // expected to return an eventData object.
    build: null
  };
  var requiredData = interfaceData.requiredData,
      eventDefaults = interfaceData.eventDefaults,
      build = interfaceData.build; // Common defaults which all sample events share.

  var commonEventDefaults = (0, _.defaults)(eventDefaults, {
    created: Date.now()
  });
  return function () {
    var sampleEventData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    sampleEventData = (0, _.defaults)(sampleEventData, commonEventDefaults);
    var _sampleEventData = sampleEventData,
        created = _sampleEventData.created,
        startTime = _sampleEventData.startTime,
        timestamp = _sampleEventData.timestamp; // Make the base sample event

    requiredData.created = created;
    requiredData.timestamp = startTime || timestamp || created;
    var SampleEvent = (0, _makeBaseSampleTimelineEvent.default)(requiredData); // Override specific sample event data

    if (typeof build === 'function') {
      SampleEvent.eventData = (0, _.extend)(SampleEvent.eventData, build(sampleEventData));
    }

    return SampleEvent;
  };
};

var _default = SampleEventFactoryInterface;
exports.default = _default;
module.exports = exports.default;